<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex mu-flex-row mu-w-100">

                    <h1 class="mu-mb-00">Process definition details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

                </section>
            </div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Process engine</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">Definitions</a>

                    </li>
                    <li>{{processDefinition.name}} ({{processDefinition.id}})</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06">
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>
            <div class="mcc-row" v-if="fetchCall">
                <div class="mcc-col">
                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-show="isUndeployed" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>

                        <span>Process definition has been undeployed.</span>

                    </mcc-alert>
                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-show="processDefinition.suspended && !isUndeployed" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>

                        <span>Process definition has been suspended.</span>

                        <div style="margin-inline-start:auto">
                            <button class="mcc-button mcc-button--success" id="activateBtn" @click="activateProcess()" title="Activate">
                                <mcc-icon name="play" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Activate</span>
                            </button>

                        </div>
                    </mcc-alert>
                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-show="isCategoryDeleted" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                        <strong>
                            <span>Warning!</span>
                        </strong>
                        <span>This Process is associated with category which is either deleted or renamed.</span>
                    </mcc-alert>
                    <mcc-alert role="alert" class="mcc-alert mcc-alert--success mcc-alert--compact" v-show="!processDefinition.suspended && isLatest && !isFutureSuspendDef" color="success">
                        <mcc-icon name="ok" aria-hidden="true" icon-set="fluency-color"></mcc-icon>

                        <span>This process definition is active.</span>

                        <div style="margin-inline-start:auto">
                            <button class="mcc-button mcc-button--success mcc-button--sm" id="suspendeBtn" @click="handleSuspendBtnClick()" title="Suspend">
                                <mcc-icon name="pause" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Suspend</span>
                            </button>

                        </div>
                    </mcc-alert>
                    <mcc-alert role="alert" class="mcc-alert mcc-alert--success mcc-alert--compact" v-show="!processDefinition.suspended && isLatest && isFutureSuspendDef" color="success">
                        <mcc-icon name="thumbs_up" aria-hidden="true"></mcc-icon>

                        <span v-if="suspendProcessInstances">This process definition will be suspended with instances on {{futureSuspensionDate}}</span>
                        <span v-if="!suspendProcessInstances">This process definition will be suspended on {{futureSuspensionDate}}</span>

                        <div style="margin-inline-start:auto">
                            <button class="mcc-button mcc-button--outline" title="Cancel" id="deletTimJob" @click="deleteTimerJob()">
                                <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                            </button>

                        </div>
                    </mcc-alert>
                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-show="!isLatest" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                        <span>This process definition is not active as there is a newer version deployed. <router-link id="viewlatestLink" :to="CONTEXT_PATH + '/processengine/processdefinitions/' + latestProcId">View active definition</router-link>
                        </span>
                    </mcc-alert>

                </div>

            </div>
            <div class="mcc-row">
                <div class="mcc-col mcc-col-md-6">
                    <div class="mcc-card fullHeightCard" v-if="fetchCall">
                        <div class="mcc-card__header">
                            <h2 class="mcc-card__title  ">Details</h2>
                        </div>
                        <div class="mcc-card__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <label>Name</label>
                                        </div>

                                        <div class="mcc-col">
                                            <label>{{processDefinition.name}}</label>
                                        </div>
                                    </div>
                                    <div class="separator"></div>

                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <label>Description</label>
                                        </div>

                                        <div class="mcc-col">
                                            <label>{{processDefinition.description}}</label>
                                        </div>
                                    </div>

                                    <div class="separator"></div>

                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <label>Key</label>
                                        </div>

                                        <div class="mcc-col">
                                            <label>{{processDefinition.key}}</label>
                                        </div>
                                    </div>
                                    <div class="separator"></div>

                                    <div class="mcc-row">
                                        <div class="mcc-col">

                                            <label>ID</label>

                                        </div>
                                        <div class="mcc-col">
                                            <label>{{processDefinition.id}}</label>
                                        </div>
                                    </div>
                                    <div class="separator"></div>
                                    <div class="mcc-row">
                                        <div class="mcc-col">

                                            <label>Category</label>

                                        </div>
                                        <div class="mcc-col">
                                            <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
                                                <div class="mcc-row">

                                                    <section class="mcc-col mu-d-flex mu-flex-row">
                                                        <label class="mu-mb-04">{{processDefinition.category}}</label>
                                                        <mcc-icon class="pointerCursor" @click="openUpdateCatDialog" name="edit" aria-hidden="true"></mcc-icon>
                                                    </section>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="separator"></div>
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <label>Version</label>
                                        </div>

                                        <div class="mcc-col">
                                            <label>{{processDefinition.version}}</label>
                                        </div>
                                    </div>
                                    <div class="separator"></div>

                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <label>Deployment</label>
                                        </div>

                                        <div class="mcc-col">
                                            <label>{{deployment.name}}</label>
                                        </div>
                                    </div>
                                    <div class="separator"></div>

                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <label>Active instances</label>
                                        </div>

                                        <div class="mcc-col">
                                            <label>{{activeInstances}}</label>
                                        </div>
                                    </div>
                                    <div class="separator" v-if="processStartURL && !processDefinition.suspended"></div>

                                    <div class="mcc-row" v-if="processStartURL && !processDefinition.suspended">
                                        <div class="mcc-col">
                                            <label>Process start URL</label>
                                        </div>

                                        <div class="mfc-input-wrapper mu-d-block form-input-container"  >

                                            <div class="mfc-input-group">

                                                <input type="text" id="processStartURL" readonly="" name="processStartURL" :value="processStartURL" @click="handleCopyProcessURLBtn()">
                                                <!-- <button class="mcc-button mcc-button--default" id="copyProcessURLBtn" title="Copy">
<mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label"></span></button> -->

                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
                <div class="mcc-col mcc-col-md-6">
                    <div class="mcc-card fullHeightCard">
                        <div class="mcc-card__header">
                            <h2 class="mcc-card__title  ">Candidate starters</h2>
                        </div>
                        <div class="mcc-card__body">
                            <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact" v-show="!identityUsers.length || !identityGroups.length" ref="noUserGroupalert" >
                                <mcc-icon name="info_popup" aria-hidden="true"></mcc-icon>
                                <span>Any user can start this process. Add user/group to restrict access.</span>
                                <button class="mcc-button mcc-button--info mcc-button--sm  mcc-alert__button--hide">
    <span class="mcc-button__label">Close</span>
  </button>
                                
                            </mcc-alert>
                            <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact" ref="userGroupalert" v-show="identityUsers.length || identityGroups.length">
                                <mcc-icon name="info_popup" aria-hidden="true"></mcc-icon>
                                <span>Only following user/groups can start this process.</span>
                                <button class="mcc-button mcc-button--info mcc-button--sm mcc-alert__button--hide">
    <span class="mcc-button__label">Close</span>
  </button>
                              
                            </mcc-alert>

                            <div class="mcc-row">
                                <div class="mcc-tabs mcc-tabs--compact mcc-tabs--pill">
                                    <input type="radio" id="as-default-tab1" name="as-default-tab-control" checked="">
                                    <input type="radio" id="as-default-tab2" name="as-default-tab-control">
                                    <ul role="tablist" class="mu-mb-05">
                                        <li role="tab">
                                            <label for="as-default-tab1" tabindex="0">
                                                <span>Users</span>
                                            </label>
                                        </li>
                                        <li role="tab">
                                            <label for="as-default-tab2" tabindex="0">
                                                <span>Groups</span>
                                            </label>
                                        </li>
                                    </ul>
                                    <div role="tabpanel">
                                        <div class="mcc-col">
                                            <button class="mcc-button mcc-button--sm mcc-button--soft-primary mu-mb-04" id="openAddUserDialogBtn" @click="openAddUserDialog()" title="Add user">
                                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add user</span>
                                            </button>
                                            <div v-if="!identityUsers.length">No users specified.</div>
                                            <div class="mcc-table--striped mcc-table--bordered mu-overflow-auto">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Users</th>
                                                            <th scope="col">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(userInfo,key) in identityUsers" :key="key">
                                                            <td class="align-middle mu-text-wrap">{{userInfo.user}}</td>
                                                            <td class="text-center">
                                                                <button class="mcc-button mcc-button--sm mcc-button--icon-only mcc-button--soft-danger" title="Delete" @click="openRemoveUserDialog(userInfo.user)">
                                                                    <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label"></span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>

                                        </div>
                                    </div>
                                    <div role="tabpanel">
                                        <div class="mcc-col">
                                            <button class="mcc-button mcc-button--sm mcc-button--soft-primary mu-mb-04" id="openAddGroupDialogBtn" @click="openAddGroupDialog()" title="Add group">
                                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add group</span>
                                            </button>

                                            <div v-if="!identityGroups.length">No groups specified.</div>
                                            <div class="mcc-table--striped mcc-table--bordered mu-overflow-auto" >
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Groups</th>
                                                            <th scope="col">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(groupInfo,key) in identityGroups" :key="key">
                                                            <td class="align-middle">{{groupInfo.group}}</td>
                                                            <td class="text-center" style="width: 19%;">
                                                                <button class="mcc-button mcc-button--sm mcc-button--icon-only mcc-button--soft-danger" title="Delete" @click="openRemoveGroupDialog(groupInfo.group)">
                                                                    <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label"></span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            <div class="mcc-row">
                <div class="mcc-col">
                    <div class="mcc-card mu-mt-06">
                        <div class="mcc-card__header">
                            <h2 class="mcc-card__title  ">Diagram</h2>
                        </div>
                        <div class="mcc-card__body">
                            <div id="oldSvgContainer" v-html="image" name="modelImage" class="modelImageOverflow"></div>

                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class=" mcc-dialog mcc-dialog--primary mcc-dialog--xs " ref="suspendDialog" id="suspendDialog">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Suspend</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.suspendDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                
                                <div class="flatpickr mfc-input-wrapper mfc-input-wrapper--width input-gap" ref="suspendDateTimePicker">
                                    <label for="inputGroupDefault1">Suspension datetime</label>
                                    <div class="mfc-input-group flatpickr-date--width flatPickrDiv mfc-input-group--has-help-text mfc-input-group--has-validation-text" id="CreatedateSelect">
                                        <input type="text" placeholder="Select Date.." data-input ref="createdDateinput" id="createdDateId" name="suspendDateTimePicker" block prepend icon="calendar">
                                        <button type="button" class="mcc-button mcc-button--soft-secondary mcc-button--icon-only" data-toggle>
                                            <mcc-icon aria-hidden="true" name="calendar"></mcc-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="mfc-checkbox-wrapper form-input-container" ref="suspendInstance" name="suspendInstance" id="suspendInstance" color="primary">
                                    <input type="checkbox" id="mds-mPjaGrwE" class="mfc-switch">
                                    <label for="mds-mPjaGrwE">Suspend running instances?</label>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.suspendDialog.close()">Close</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="suspendProcess()">Suspend</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog mcc-dialog--primary mcc-dialog--xs" ref="updateCatDialog" id="updateCatDialog">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Choose a category</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.updateCatDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div v-show="fetchCatCall" class="mfc-slim-select-wrapper mu-mb-03">
                                        <select class="mfc-slim-select" aria-label="single_radio_input" ref="selectCategoryCmp" name="selectCategoryCmp" id="selectCategoryCmp">
                                            <option value=" " :selected="processDefinition.category ==''"></option>
                                            <option v-for="(cat,key) in categoryList" :selected="processDefinition.category == cat.name" :key="key" :value="cat.name">{{cat.name}}</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.updateCatDialog.close()">Close</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="updateCat()">Save category</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog mcc-dialog--primary mu-overflow-visible mcc-dialog--xs" ref="addNewUserDialog" id="addNewUserDialog">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Choose a user</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.addNewUserDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body mu-overflow-visible">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div v-show="fetchUserCall">
                                        <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mu-mb-03">
                                            <label for="selectGroupCmp">User</label>
                                            <div id="UserInvolvingselectIdDiv"></div>
                                            <select class="mfc-slim-select" aria-label="single_radio_input" required ref="selectUserCmp" name="selectUserCmp" id="selectUserCmp" block>
                                                <option value=""></option>
                                                <option v-for="(user,key) in userList" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.addNewUserDialog.close()">Close</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="addUser()">Add user</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog mcc-dialog--primary mu-overflow-visible mcc-dialog--xs" ref="addNewGroupDialog" id="addNewGroupDialog">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Choose a group</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.addNewGroupDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body mu-overflow-visible">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div v-show="fetchGroupCall">
                                        <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mu-mb-03">
                                            <label for="selectGroupCmp">Group</label>
                                            <div id="InvolvingselectIdDiv"></div>
                                            <select class="mfc-slim-select" aria-label="single_radio_input" required ref="selectGroupCmp" name="selectGroupCmp" id="selectGroupCmp" block>
                                                <option v-for="(group,key) in groupList" :key="key" :value="group.name">{{group.name}}</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.addNewGroupDialog.close()">Close</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="addGroup()">Add group</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--xs" v-if="fetchCall" ref="copyURLDialog" id="share-dialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Share process start URL</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.copyURLDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <form novalidate>

                        <div>
                            <div class="mfc-input-wrapper form-input-container" title="Standalone URL" >
                                <label for="mds-iHCK7YrF">Standalone</label>
                                <div class="mfc-input-group"  @click="copyToClipbord(processStartUrlStandalone)">

                                    <input type="text" name="prompt-text-entry" readonly="" id="prompt-text-entry" :value="processStartUrlStandalone">
                                    <button  type="button" class="mcc-button mcc-button--soft-secondary">Copy</button>


                                </div>
                            </div>
                        </div>
                        <div class="mt-1">
                            <div class="mfc-input-wrapper form-input-container" title="Integrated URL" >
                                <label for="mds-hPs6aJWF">Integrated</label>
                                <div class="mfc-input-group" @click="copyToClipbord(processStartURL)">

                                    <input type="text" name="prompt-text-entry1" readonly="" id="prompt-text-entry1"  :value="processStartURL">
                                    <button  type="button" class="mcc-button mcc-button--soft-secondary">Copy</button>


                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">

                        <button type="button" class="mcc-button mcc-button--info" @click="$refs.copyURLDialog.close()">Close</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" color="danger" ref="removeUserDialog" id="removeUserDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Remove user</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.removeUserDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Are you sure you want to remove "{{removeUsername}}" as a candidate starter for this process ?

                        </div>

                    </div>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.removeUserDialog.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="handleRemoveUserDialogClose($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" color="danger" ref="removeGroupDialog" id="removeGroupDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Remove group</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.removeGroupDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Are you sure you want to remove "{{removeGroup}}" as a candidate starter for this process ?

                        </div>

                    </div>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.removeGroupDialog.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="handleRemoveGroupDialogClose($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>

</div>
</template>

<script>
import constantMessages from "../../../messages";
import DefinitionAPI from "../../../services/DefinitionAPI";
import {
    EventBus
} from "../../../services/event-bus";
import Utils from "../../../script_utils";

export default {
    name: "DefinitionEdit",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP[
                "processengine.processdefinitions.edit"
            ],
            processDefinition: {},
            deployment: {},
            defId: this.$route.params.defId,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            fetchCall: false,
            showHelpText: false,
            image: "",
            activeInstances: "",
            candidateUserCount: "",
            isFutureSuspendDef: false,
            suspendProcessInstances: false,
            runtimeJobId: "",
            futureSuspensionDate: "",
            isLatest: false,
            isUndeployed: false,
            latestProcId: "",
            isCategoryDeleted: false,
            processStartURL: "",
            processStartUrlStandalone: "",
            categoryList: {},
            fetchCatCall: false,
            fetchUserCall: false,
            fetchGroupCall: false,
            identityUsers: [],
            identityGroups: [],
            userList: [],
            groupList: [],
            removeUsername: "",
            removeGroup: "",
            updateCall: true,
          

        };
    },
    watch: {
    'image'() {
      this.$nextTick(() => {
        this.setViewBoxForSVG();
      });
    }
  },
    updated() {
        this.flatpickr()
    },
    mounted() {

        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        DefinitionAPI.getDefinitionDetails(this.$route.params.defId)
            .then(result => {
                if (result == null) {
                    self.$router.push(
                        self.CONTEXT_PATH + "/processengine/processdefinitions"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process definition."
                    });
                    return;
                }
                self.processDefinition = result.processDefinition;
                self.deployment = result.deployment;
                self.candidateUserCount = parseInt(result.candidateUserCount);
                self.activeInstances = result.activeInstances;
                self.image = result.image;
                self.isFutureSuspendDef = result.isFutureSuspendDef;
                self.runtimeJobId = result.runtimeJobId;
                self.futureSuspensionDate = result.futureSuspensionDate;
                self.suspendProcessInstances = result.suspendProcessInstances;
                self.isLatest = result.isLatest;
                self.isUndeployed = result.isUndeployed;
                self.latestProcId = result.latestProcId;
                self.isCategoryDeleted = result.isCategoryDeleted;
                self.identityUsers = result.identityUsers;
                self.identityGroups = result.identityGroups;
                self.createProcessStartUrl();

                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.processdefination.details"] + " - " + self.processDefinition.name;
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(() => {
                self.fetchCall = true;
                self.updateSVG();
                let selectCategoryCmp = new SlimSelect({
                    select: '#selectCategoryCmp',
                   
                });
                let selectUserCmp = new SlimSelect({
                    select: '#selectUserCmp',
                         settings: {
                        contentPosition: 'absolute',
                        contentLocation: document.getElementById('UserInvolvingselectIdDiv')
                    }
                });

                let selectGroupCmp = new SlimSelect({
                    select: '#selectGroupCmp',
                    settings: {
                        contentPosition: 'absolute',
                        contentLocation: document.getElementById('InvolvingselectIdDiv')
                    }
                });
            });
    },
    methods: {
        setViewBoxForSVG() {
      const svgElement = this.$el.querySelector('#oldSvgContainer svg');
      if (svgElement) {
        const bbox = svgElement.getBBox(); 
            svgElement.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
      }
    },
        handleCopyProcessURLBtn() {
            this.$refs.copyURLDialog.show();
        },
        flatpickr() {
            let self = this;
            self.suspendDateFlatPickrInstance = flatpickr('.flatPickrDiv', {
                dateFormat: 'm/d/Y, H:i',
                altFormat: 'd/m/Y, h:i K',
                enableTime: true,
                time_24hr: false,
                wrap: true,
                altInput:true
            })
        },
        createProcessStartUrl() {
            if (this.isLatest && this.candidateUserCount > 0 && this.processDefinition != null && !this.processDefinition.suspended) {
                this.processStartURL = window.location.origin + this.CONTEXT_PATH + "/processes/viewprocess/" + this.processDefinition.key;
                this.processStartUrlStandalone = window.location.origin + this.CONTEXT_PATH +
                    "/standalone/external/processes/viewprocess/" + this.processDefinition.key + "." + Buffer.from(this.processDefinition.tenantId).toString('base64');
            } else {
                this.processStartURL = null;
            }
        },
        copyToClipbord(text) {
            navigator.clipboard.writeText(text)
            EventBus.$emit("success-notification", {
                msg: "URL copied to clipboard"
            });
        },
        updateSVG() {
            Utils.updateSVG("oldSvgContainer");
        },
        handleSuspendBtnClick() {
            this.$refs.suspendDialog.show();
        },
        closeSuspendDialog() {
            this.$refs.createdDateinput.value = "";
            this.$refs.suspendInstance.checked = false;
        },
        openUpdateCatDialog() {
            let self = this;
            self.fetchCatCall = false;
            self.categoryList = {};
            DefinitionAPI.getCategories()
                .then(result => {
                    self.categoryList = result.data;
                })
                .finally(() => {
                    self.fetchCatCall = true;
                    self.$refs.updateCatDialog.show();
                });
        },
        addUser() {
            let self = this;
            let selectedUser = this.$refs.selectUserCmp.value;
            // self.$refs.addNewUserDialog.enableConfirm(false);
            self.updateCall = false;
            DefinitionAPI.addNewUser(this.defId, selectedUser).then(result => {
                self.updateCall = true;
                self.identityUsers = result.identityUsers;
                self.candidateUserCount = parseInt(result.candidateUserCount);
                self.createProcessStartUrl();
                self.$refs.addNewUserDialog.close();
                EventBus.$emit('success-notification', {
                    "msg": "User added successfully"
                });
                self.$refs.addNewUserDialog.enableConfirm(true);
            });
        },
        openAddUserDialog() {
            let self = this;
            self.fetchUserCall = false;
            self.userList = {};
            DefinitionAPI.getUsers(this.$route.params.defId)
                .then(result => {
                    self.userList = result.data;
                })
                .finally(() => {
                    self.fetchUserCall = true;
                    self.$refs.addNewUserDialog.show();
                });
        },

        openRemoveUserDialog(user) {
            this.removeUsername = user;
            this.$refs.removeUserDialog.show();
        },
        handleRemoveUserDialogClose(e) {
            let self = this;
            DefinitionAPI.removeUser(this.defId, this.removeUsername).then(result => {

                self.identityUsers = result.identityUsers;
                self.candidateUserCount = parseInt(result.candidateUserCount);
                self.createProcessStartUrl();
                self.$refs.removeUserDialog.close();
                self.removeUsername = "";

                EventBus.$emit('success-notification', {
                    "msg": "User removed successfully"
                });
            });

        },
        openRemoveGroupDialog(group) {
            this.removeGroup = group;
            this.$refs.removeGroupDialog.show();
        },
        handleRemoveGroupDialogClose(e) {
            let self = this;
            DefinitionAPI.removeGroup(this.defId, this.removeGroup).then(result => {
                self.identityGroups = result.identityGroups;
                self.candidateUserCount = parseInt(result.candidateUserCount);
                self.createProcessStartUrl();
                self.$refs.removeGroupDialog.close();
                self.removeGroup = "";
                EventBus.$emit('success-notification', {
                    "msg": "Group removed successfully"
                });
            });

        },
        addGroup() {
            let self = this;
            let selectedGroup = this.$refs.selectGroupCmp.value;
            // self.$refs.addNewGroupDialog.enableConfirm(false);
            self.updateCall = false;
            DefinitionAPI.addNewGroup(this.defId, selectedGroup).then(result => {
                self.updateCall = true;
                self.identityGroups = result.identityGroups;
                self.candidateUserCount = parseInt(result.candidateUserCount);
                self.createProcessStartUrl();
                self.$refs.addNewGroupDialog.close();
                EventBus.$emit('success-notification', {
                    "msg": "Group added successfully"
                });
                self.$refs.addNewGroupDialog.enableConfirm(true);
            });
        },
        openAddGroupDialog() {
            let self = this;
            self.fetchGroupCall = false;
            self.groupList = {};
            DefinitionAPI.getGroups(this.$route.params.defId)
                .then(result => {
                    self.groupList = result.data;
                    console.log(self.groupList);
                })
                .finally(() => {
                    self.fetchGroupCall = true;
                    self.$refs.addNewGroupDialog.show();
                });
        },
        updateCat() {
            let self = this;
            let selectedCategory = this.$refs.selectCategoryCmp.value;
            if (selectedCategory != null) {
                selectedCategory = selectedCategory.trim();
            }
            self.updateCall = false;
            DefinitionAPI.updateCategory(this.defId, selectedCategory).then(result => {
                self.updateCall = true;
                if (!result.error) {
                    self.processDefinition.category = selectedCategory;
                    self.$refs.updateCatDialog.close();
                    EventBus.$emit('success-notification', {
                        "msg": "Category updated successfully"
                    });
                } else {
                    EventBus.$emit('warning-notification', {
                        "msg": "Could not process your request"
                    });
                }
            });
        },
        // closeUpdateCatDialog() {
        //     this.fetchCatCall = false;
        // },
        closeAddUserDialog() {
            this.fetchUserCall = false;
        },
        closeAddGroupDialog() {
            this.fetchGroupCall = false;
        },
        suspendProcess() {
            let date = this.$refs.createdDateinput.value;
            let responseMsg = "Process definition suspended successfully";
            if (date != "") {
                let currentTime = new Date().toISOString();
                let differenceDate = new Date(date) - new Date(currentTime);
                if (differenceDate < 0) {
                    date = "";
                }
            }

            let includeProcessInstances = this.$refs.suspendInstance.checked;
            let requestBody = {};
            if (date != "") {
                responseMsg = "Process definition will be suspended";
                requestBody = {
                    "suspendTime": new Date(date),
                    "includeInstance": includeProcessInstances
                };
            } else {
                requestBody = {
                    "includeInstance": includeProcessInstances
                };
            }

            this.$refs.suspendDialog.close();
            let self = this;
            return DefinitionAPI.suspendProcess(requestBody, this.$route.params.defId).then(response => {
                if (!response.error) {
                    self.suspendProcessInstances = includeProcessInstances;
                    if (date != "") {
                        self.isFutureSuspendDef = true;
                        self.futureSuspensionDate = new Date(date).toLocaleString("en-GB").replace(/\,/g, '');
                    } else {
                        self.processDefinition.suspended = true;
                    }
                    EventBus.$emit('success-notification', {
                        "msg": responseMsg
                    });
                } else {
                    EventBus.$emit('warning-notification', {
                        "msg": "Could not process your request."
                    });
                }
            });
        },
        activateProcess() {
            let self = this;
            let requestBody = {
                "action": "activate"
            };
            return DefinitionAPI.activateProcess(requestBody, this.$route.params.defId).then(response => {
                if (!response.error) {
                    self.suspendProcessInstances = false;
                    self.processDefinition.suspended = false;
                    self.isFutureSuspendDef = false;
                    self.futureSuspensionDate = "";
                    EventBus.$emit('success-notification', {
                        "msg": "Process definition activated successfully"
                    });
                } else {
                    EventBus.$emit('warning-notification', {
                        "msg": "Could not process your request"
                    });
                }
            });
        },
        deleteTimerJob() {
            let self = this;
            return DefinitionAPI.deleteTimerJob(this.$route.params.defId).then(response => {
                if (!response.error) {
                    self.isFutureSuspendDef = false;
                    self.suspendProcessInstances = false;
                    self.futureSuspensionDate = "";
                    self.processDefinition.suspended = false;
                    EventBus.$emit('success-notification', {
                        "msg": "Process definition suspension is cancelled"
                    });
                } else {
                    EventBus.$emit('warning-notification', {
                        "msg": "Could not process your request"
                    });
                }
            });
        },
        redirectToList() {
            localStorage.setItem("definitionlist", "definitionlist");

            this.$router.push(
                this.CONTEXT_PATH + '/processengine/processdefinitions'
            );
        }
    }
};
</script>
<style scoped>
@import "../../../assets/css/symbol.css";
</style>
<style scoped>
.modelImageOverflow {
    overflow-x: auto;
    max-width: calc(100vw - 400px);
}

.candidateHeader {
    line-height: 34px;
    font-weight: bold;
}

.flatpickr-date--width>.numInput.cur-year {
    width: auto !important;
}

#createdDateId {
    color: black !important;
}
</style>
